import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectedRelatedDataButton, selectedRelatedEntity, pushPostApiResponse, pushTableData } from '../../slices/customQueryHeaderSlice';
import { StyledLabel, StyledDiv, StyledLabelGrid } from './RelatedDataStyle';
import Grid from '@material-ui/core/Grid';
import StyledPill from '../../components/StyledPill/StyledPill';
import StyledPillContainer from '../../components/StyledPillContainer/StyledPillContainer';
import { deleteChipArrayAddCriteria, pushSelectedChipArray, pushShowCard, pushChipArrayAddCriteria, pushShowTable, pushCheckTableData } from '../../slices/customQueryBodySlice';

const RelatedData = () => {
  const showRelatedDataType = useSelector(state => state.customQueryHeader.showRelatedData);
  const relatedDataButton = useSelector(state => state.customQueryHeader.relatedDataButton);
  const selectedEntity = useSelector(state => state.customQueryHeader.selectedDataType);
  const contextualPath = useSelector(state => state.customQueryHeader.showPath);
  const relatedData = useSelector(state => state.customQueryHeader.relatedData);
  const selectedRelatedButton = useSelector(state => state.customQueryHeader.relatedDataButton);
  const selectedchipArray = useSelector(state => state.customQueryBody.ChipArrayAddCriteria) || [];
  const dispatch = useDispatch();

  const handleSelectRelatedEntityButtons = (event, value) => {
    let arr = [];
    relatedData.map(selectedData => {
      let obj = {};

      if (value.length > 0) {
        value.forEach(entityString => {
          if (selectedData.name === entityString && !relatedDataButton.includes(obj.disabledIfSelected)) {
            obj = { ...selectedData,
              isSelected: true
            };
          } else if (obj.name !== selectedData.name) {
            obj = { ...selectedData,
              isSelected: false
            };
          }
        });
      } else {
        obj = { ...selectedData,
          isSelected: false
        };
      }

      arr.push(obj);
    });

    if (selectedchipArray.length > 0 && value.length > 0) {
      let newArray = [];
      selectedchipArray.forEach(selctedChip => {
        let relatedDataButtons = relatedData.map(item => {
          return item.name;
        });
        let newsplitedvalue;
        let splittedchip = selctedChip.split(' ');

        if (splittedchip[0] == 'Service') {
          newsplitedvalue = splittedchip[1] + 's';
        } else if (splittedchip[0] == 'User') {
          newsplitedvalue = splittedchip[0] + ' ' + splittedchip[1] + 's';
        } else {
          newsplitedvalue = splittedchip[0] + 's';
        }

        if (relatedDataButtons.includes(newsplitedvalue)) {
          if (newsplitedvalue === 'Groups' || newsplitedvalue === 'Roles' || newsplitedvalue === 'Permissions' || newsplitedvalue === 'Resources' || newsplitedvalue === 'User Accounts') {
            if (value.includes(newsplitedvalue)) {
              newArray.push(selctedChip);
            }
          }
        } else {
          newArray.push(selctedChip);
        }
      });
      dispatch(deleteChipArrayAddCriteria(newArray));
      dispatch(pushSelectedChipArray(newArray));
      dispatch(pushChipArrayAddCriteria(newArray));
    }

    dispatch(selectedRelatedEntity(arr));
    dispatch(selectedRelatedDataButton(value));
    dispatch(pushCheckTableData(false));
    let data = {
      data: '',
      type: 'run'
    };
    dispatch(pushPostApiResponse(data));
    let savedata = {
      data: '',
      type: 'save'
    };
    dispatch(pushPostApiResponse(savedata));
    let queryResults = {
      data: [],
      totalCount: 0,
      totalPages: 0
    };
    dispatch(pushTableData(queryResults));
    dispatch(pushShowTable(false));
    dispatch(pushShowCard(false));

    if (value.length === 0) {
      dispatch(pushSelectedChipArray([]));
      dispatch(deleteChipArrayAddCriteria([]));
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(StyledLabelGrid, null, /*#__PURE__*/React.createElement(StyledLabel, null, "Related Entity (optional)")), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, showRelatedDataType && selectedEntity ? contextualPath ? /*#__PURE__*/React.createElement(StyledPillContainer, null, selectedRelatedButton.map((button, index) => {
    return /*#__PURE__*/React.createElement(StyledPill, {
      key: index,
      "aria-label": button,
      value: button,
      selected: button
    }, button);
  })) : /*#__PURE__*/React.createElement(StyledPillContainer, {
    value: relatedDataButton,
    onChange: handleSelectRelatedEntityButtons
  }, relatedData.map((relatedDataItem, index) => {
    return /*#__PURE__*/React.createElement(StyledPill, {
      key: index,
      "aria-label": relatedDataItem.name,
      value: relatedDataItem.name,
      selected: relatedDataItem.isSelected,
      disabled: relatedDataButton.includes(relatedDataItem.disabledIfSelected)
    }, relatedDataItem.name);
  })) : /*#__PURE__*/React.createElement(StyledDiv, null, "* Related Entity will be available based on entity selected"))));
};

export default RelatedData;